export default {
      id: "menu__personnel-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__personnel",
      toString: function () {
        return this.url;
      }
    }